<template>
    <form class="card">
        <h3>QR code</h3>
        <div v-if="data">
            <div id="parking-qr" class="form-item">
                <div class="qr-code">
                  <div class="qr-code__wrapper">
                    <img :src="data.qr">
                    <div class="qr-code__address">{{ data.short_address || data.address }}</div>
                  </div>
                </div>
            </div>
           <div class="button _free _accept form-item" @click="downloadQr">Скачать код</div>
        </div>

        <div class="form-item" v-if="status == '' && !data">
            <div class="button _free" @click="generateQr">Сгенерировать</div>
        </div>
    </form>
</template>

<script>
    import domtoimage from 'dom-to-image';

    export default {
        props: ['status', 'data'],
        created () {
            this.$emit('getData')
        },
        methods: {
            downloadQr () {
                let node = document.getElementById('parking-qr');
                domtoimage.toJpeg(node, { quality: 0.95 })
                    .then(function (dataUrl) {
                        let link = document.createElement('a');
                        link.download = 'my-image-name.jpeg';
                        link.href = dataUrl;
                        link.click();
                    });
            },
            generateQr () {

            }
        }
    }
</script>